import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

// Extend dayjs with the relativeTime plugin
dayjs.extend(relativeTime);

/**
 * Formats a date string into a "time ago" format using Day.js
 * @param dateString ISO date string
 * @returns formatted string like "10 hours ago", "2 days ago", etc.
 */
export function timeAgo(dateString: string): string {
  // If the date string is invalid, return the original string
  if (!dateString || dayjs(dateString).toString() === 'Invalid Date') {
    return dateString;
  }
  
  return dayjs().to(dayjs(dateString));
}

/**
 * Formats a date string into a short "time ago" format using Day.js
 * @param dateString ISO date string
 * @returns formatted string like "10h ago", "2d ago", etc.
 */
export function shortTimeAgo(dateString: string): string {
  if (!dateString || dayjs(dateString).toString() === 'Invalid Date') {
    return dateString;
  }

  const now = dayjs();
  const date = dayjs(dateString);
  const diffInSeconds = now.diff(date, 'second');
  
  if (diffInSeconds < 60) {
    return 'just now';
  } else if (diffInSeconds < 3600) {
    return `${Math.floor(diffInSeconds / 60)}m ago`;
  } else if (diffInSeconds < 86400) {
    return `${Math.floor(diffInSeconds / 3600)}h ago`;
  } else if (diffInSeconds < 604800) {
    return `${Math.floor(diffInSeconds / 86400)}d ago`;
  } else if (diffInSeconds < 2592000) {
    return `${Math.floor(diffInSeconds / 604800)}w ago`;
  } else if (diffInSeconds < 31536000) {
    return `${Math.floor(diffInSeconds / 2592000)}mo ago`;
  } else {
    return `${Math.floor(diffInSeconds / 31536000)}y ago`;
  }
}
